module.exports = __webpack_public_path__ + "static/media/senger.f85c0593.mp3";